import { render, staticRenderFns } from "./AsidePopup.vue?vue&type=template&id=3500ecae&scoped=true&"
import script from "./AsidePopup.vue?vue&type=script&lang=js&"
export * from "./AsidePopup.vue?vue&type=script&lang=js&"
import style0 from "./AsidePopup.vue?vue&type=style&index=0&id=3500ecae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3500ecae",
  null
  
)

component.options.__file = "AsidePopup.vue"
export default component.exports